import React from 'react'
import View from './view'

const StaffList = ({ ...props }) => {
    return <View {...props} />
}

export default StaffList